/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Workout',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M12 1.867c1.505 0 2.724 1.22 2.725 2.725-.024.485-.123.942-.371 1.368l3.402-.543c1.092-.211 2.136.617 2.137 1.749-.036.867-.63 1.621-1.518 1.745l-3.837.534v2.773l2.067 7.71c.202.928-.282 1.888-1.237 2.144a1.75 1.75 0 0 1-2.143-1.238l-1.221-4.546-1.219 4.546c-.251.933-1.21 1.488-2.144 1.238a1.75 1.75 0 0 1-1.236-2.144l2.056-7.667V9.445l-3.837-.534c-.887-.124-1.481-.878-1.518-1.745.001-1.132 1.044-1.96 2.137-1.749l3.401.543c-.248-.426-.346-.883-.37-1.368 0-1.505 1.22-2.725 2.725-2.725zm6.693 5.299c0-.358-.338-.643-.709-.571-1.971.382-3.973.706-5.984.733-1.88 0-4.434-.433-5.984-.733-.371-.071-.709.213-.709.571a.56.56 0 0 0 .484.556l4.099.572c.442.062.771.441.771.888v3.123a.9.9 0 0 1-.03.232l-2.066 7.702a.55.55 0 0 0 .388.673c.293.079.597-.095.676-.389l1.512-5.641c.223-.829 1.34-.882 1.675-.156l1.569 5.797a.55.55 0 0 0 .674.389c.312-.083.437-.379.39-.673l-2.078-7.745a.9.9 0 0 1-.03-.232v-3.08c0-.447.329-.826.771-.888l4.099-.572a.56.56 0 0 0 .484-.556zM12 3.066c-.842 0-1.525.683-1.525 1.525S11.158 6.117 12 6.117s1.525-.683 1.525-1.525S12.842 3.066 12 3.066z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
